import React, { useEffect } from 'react';
import { retrieveLaunchParams } from '@telegram-apps/sdk-react';
import axios from 'axios';

const AuthUser = ({ onAuthSuccess }) => {
  useEffect(() => {
    const authenticate = async (attempt = 1) => {
      try {
        const { initDataRaw, initData } = retrieveLaunchParams();
    
        const response = await axios.post(process.env.REACT_APP_API_URL + '/api/authentication/UserAuth', {
          initData: initDataRaw,
          hash: initData.hash,
          hashuser: initData.user
        });
    
        if (response.data.access_token) {
          localStorage.setItem('jwtToken', response.data.access_token);
          localStorage.setItem('jwtName', response.data.name);
          localStorage.setItem('jwtId', response.data.id);
          onAuthSuccess();
          return;
        }
      } catch (error) {
        console.error(`Authentication failed (Attempt ${attempt}/10):`, error);
    
        if (attempt < 10) {
          setTimeout(() => authenticate(attempt + 1), 5000); // Повтор через 5 секунд
        } else {
          console.error("Authentication failed after 10 attempts.");
        }
      }
    };

    authenticate();
  }, [onAuthSuccess]);

  return (
    <div className="auth-loader">
      <svg className='logo' width="268" height="268" viewBox="0 0 268 268" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="134" cy="134" r="134" fill="#D9D9D9"/>
        <circle cx="134" cy="134.002" r="128" fill="#C6FF5B" stroke="white" stroke-width="2"/>
        <line x1="6" y1="134.002" x2="261.002" y2="134.002" stroke="white"/>
        <line x1="23.0781" y1="196.818" x2="243.916" y2="69.3175" stroke="white"/>
        <line x1="69.5631" y1="243.67" x2="197.064" y2="22.8317" stroke="white"/>
        <line x1="133.246" y1="261.002" x2="133.246" y2="5.99998" stroke="white"/>
        <line x1="197.063" y1="244.17" x2="69.5621" y2="23.3317" stroke="white"/>
        <line x1="243.914" y1="197.684" x2="23.0759" y2="70.1835" stroke="white"/>
        <g filter="url(#filter0_d_818_699)">
        <circle cx="133.5" cy="134.5" r="17.5" fill="white"/>
        </g>
        <defs>
        <filter id="filter0_d_818_699" x="112" y="117" width="43" height="43" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_818_699"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_818_699" result="shape"/>
        </filter>
        </defs>
      </svg>

    </div>
  );
};

export default AuthUser;